(function(){
  var root=document.querySelector('[data-sph-finder]');
  if(!root)return;

  /* ---- Bildkacheln in Schritt 1 ---- */
  var PICS={
    terrasse:['https://cdn.shopify.com/s/files/1/1068/9953/8257/files/hf_20260810_064706_358b8269-ee67-413c-9d16-c75e2f33c8e0.png?v=1786344482','Terrassendach mit 16 mm Stegplatten'],
    wintergarten:['https://cdn.shopify.com/s/files/1/1068/9953/8257/files/hf_20260810_064706_b5360ca4-536e-4f6d-9a23-edb4552da8ea.png?v=1786344481','Wintergarten mit 25 mm Stegplatten'],
    gewaechshaus:['https://cdn.shopify.com/s/files/1/1068/9953/8257/files/hf_20260810_064706_87676470-e41d-4576-b587-7188c98ac185.png?v=1786344481','Gew\u00e4chshaus mit Hohlkammerplatten'],
    carport:['https://cdn.shopify.com/s/files/1/1068/9953/8257/files/hf_20260810_064706_def7f839-667a-4aba-8b53-fd509cc78779.png?v=1786344481','Carport mit Polycarbonat-Dach']
  };
  root.querySelectorAll('[data-sph-step="1"] .sph-fin__o').forEach(function(o){
    var v=o.getAttribute('data-val'), p=PICS[v];
    if(!p||o.querySelector('.sph-fin__pic'))return;
    var s=document.createElement('span');
    s.className='sph-fin__pic';
    s.innerHTML='<img src="'+p[0]+'&width=520" alt="'+p[1]+'" loading="lazy" width="520" height="390">';
    o.insertBefore(s,o.firstChild);
  });

  /* ---- Zurück-Button neben „Neu starten“ ---- */
  var restart=root.querySelector('[data-sph-restart]');
  var back=root.querySelector('[data-sph-back]');
  if(restart && back && !root.querySelector('[data-sph-back2]')){
    var b=document.createElement('button');
    b.type='button';
    b.className='sph-fin__back2';
    b.setAttribute('data-sph-back2','');
    b.innerHTML='<span>Zur\u00fcck</span>';
    restart.parentNode.insertBefore(b, restart);
    b.addEventListener('click',function(){ back.click(); });
  }
})();
